module.exports = __webpack_public_path__ + "img/cdvivbe-2014-10-28-1018.349fa8cd.jpg";